module.exports = __webpack_public_path__ + "img/pn.5e53affd.svg";